import { useEffect, useState } from 'react'
import pclnRequest from '@pcln/request'
import config from 'isomorphic-config'
import analytics from '../../utils/analytics'
import { RecommendedCityIds } from '../../types'

const generateQuery = (locations: RecommendedCityIds | null) => {
  return locations?.cityId.reduce((query, cityId) => {
    return `${query}
    city_${cityId.value}: cityInfo(location: "${cityId.value}") {
        cityName
        countryCode
        countryName
        stateCode
        stateName
        latitude
        longitude
        itemName: displayCityName
        lat
        lon
        cityID: cityId
      }`
  }, '')
}

const useRecommendations = (cityIds: RecommendedCityIds | null) => {
  const [recommendedCities, setRecommendedCities] = useState([])
  useEffect(() => {
    async function fetchRecommendations() {
      const query = generateQuery(cityIds)
      try {
        const { url, timeout } = config.client['pcln-graph']
        const result: any = await pclnRequest({
          url,
          timeout,
          method: 'POST',
          data: {
            query: `query { ${query} }`
          }
        })
        const formattedResponse = Object.values(result?.data?.data) as any

        setRecommendedCities(formattedResponse)
      } catch (error) {
        analytics.logError({
          message: `Failed to hotelRecommendations api. Error message: ${error}`
        })
      }
    }
    if (cityIds?.cityId.length) {
      fetchRecommendations()
    }
  }, [cityIds])

  return recommendedCities
}

export default useRecommendations
